import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSession } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const enableHandRaisedSound = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/enable-hand-sound`,
  );
  return response.data;
};

function useEnableHandRaisedSound(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => enableHandRaisedSound({ sessionId }),
    ...mutationOptions,
  });
}

const disableHandRaisedSound = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<PublicSession> => {
  const response = await axiosClient.post(
    `/sessions/${sessionId}/in-call/disable-hand-sound`,
  );
  return response.data;
};

function useDisableHandRaisedSound(
  mutationOptions?: Partial<
    UseMutationOptions<PublicSession, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => disableHandRaisedSound({ sessionId }),
    ...mutationOptions,
  });
}

export { useDisableHandRaisedSound, useEnableHandRaisedSound };
